module.exports = __webpack_public_path__ + "img/logo-um-epf-ang.c410cbdb.png";